<div class="flex align-items-center justify-content-between">
    <div class="flex align-items-center gap-2">

        <!-- Filtre sur le journal -->
        <div [class.table-filter-active]="isFilterActive('journal')">
            <p-multi-select #journalMultiSelect [resetFilterOnHide]="true" fluid [options]="journals" optionLabel="label" filterBy="label" size="small"
                placeholder="Journal" panelStyleClass="w-30rem" [autofocusFilter]="true" [filter]="true"
                [showClear]="true" [loading]="journalsLoading" [(ngModel)]="journalsSelected"
                (onChange)="buildFilters()" (onClear)="onClearMultiSelectFilter('journal', journalMultiSelect)">
                <ng-template #selecteditems let-journals>
                    @if (!!journals) {
                    <div class="pr-3">
                        @if (journals.length === 1) {
                        {{journals[0].code}} - {{journals[0].label}}
                        } @else if (journals.length > 1) {
                        <div class="flex align-items-center gap-2">
                            Journaux <p-badge size="small" [value]="journals.length" />
                        </div>
                        }
                    </div>
                    }
                </ng-template>
                <ng-template #item let-journal>
                    {{journal.code}} - {{journal.label}}
                </ng-template>
            </p-multi-select>
        </div>

        <!-- Filtre sur la période -->
        <div [class.table-filter-active]="isFilterActive('period')">
            <app-date-range-filter label="Période" [(range)]="operationDateRange"
                (rangeChange)="onSelectDateRange('period')" (cleared)="onClearDateRange('period')" />
        </div>

        <!-- Filtre sur les écritures exportées -->
        <div class="flex align-items-center gap-2">
            <p-checkbox [(ngModel)]="extractedFilter" [binary]="true" inputId="extracted"
                (ngModelChange)="buildFilters()" />
            <label for="extracted" class="cursor-pointer">Écritures exportées</label>
        </div>

    </div>

    <!-- Bouton pour réinitialiser tous les filtres -->
    <div>
        @if (filters.length > 0) {
        <p-button icon="pi pi-times" [label]="'Réinitialiser' + (activeFilterCount ? ' (' + activeFilterCount + ')' : '')" [text]="true" [rounded]="true"
            (click)="onClickResetFilters()" pTooltip="Réinitialiser tous les filtres" showDelay="1000"
            hideDelay="300"></p-button>
        }
    </div>
</div>